import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@shared/ui/dialog";
import { Button } from "@shared/ui/button";

interface PauseIntegrationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const PauseIntegrationDialog: React.FC<PauseIntegrationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Pause integration?</DialogTitle>
        </DialogHeader>
        <div className="py-4 border-y">
          <DialogDescription className="text-gray-900 text-sm">
            No data will be synced until resumed. In-flight requests will complete.
          </DialogDescription>
        </div>
        <DialogFooter className="pt-2">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            className="bg-red-500 hover:bg-red-600 text-white"
            onClick={onConfirm}
          >
            Pause
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
